import EventEmitter from 'events'
import { arrayWrap, Validator } from '../utils'

export default class BaseService {
  constructor(host, options) {
    Object.assign(this, options)
    this.host = host
    this.config = host.config
    this.httpClient = host.httpClient
  }

  // a helper method that takes any entity OR an id and returns its ID, preferably its serverId
  _resolveModelId = (thing: ?string|?Object) => {
    if (typeof thing === 'string') return thing
    return thing ? thing.serverId || thing.id || null : null
  }

  // a helper method that takes any entity OR an id and a list of types
  // if it's an entity, it ensure the type is one of the allowed types
  // if it's a string, it looks up the entity locally, and if found, ensure the type is correct
  // if not found locally, assumes it's ok (no way to tell what ID it is of)
  _resolveModelIdWithTypes(thing: ?string|?Object, allowedEntityTypes: string|string[]) {
    if (!thing) return null

    if (typeof thing === 'string') {
      const entity = this._resolveEntity(thing) // try finding in all types
      if (entity) thing = entity
      else return thing // not stored locally, assume it's ok
    }

    Validator.oneOf('thing', thing.$entityType, arrayWrap(allowedEntityTypes))

    return thing.serverId || thing.id || null
  }

  // a helper method that gets a unique ID of a model and looks it up locally by .id or .serverId
  // all entities should have a unique ID so it's safe
  // list of types to look in defaults to all entity types
  _resolveEntity(id: ?string|?Object, types: ?string|?string[]) {
    if (types) {
      types = arrayWrap(types)
    } else {
      types = this.host.allModelEntityTypes
    }

    if (typeof id === 'object') {
      if (id.$entityType) {
        Validator.oneOf('thing', id.$entityType, types)
        types = [id.$entityType]
      }
      id = id.id
    }

    for (const type of types) {
      let entity = this.host.modelsByEntityType[type].get(id)
      if (entity) return entity
    }

    return null
  }

  mounted() {}

  dispose() {}
}

Object.assign(BaseService.prototype, EventEmitter.prototype)
